// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import {
  ActionSheetV2,
  Body,
  Description,
  Icon,
  InlineAlert,
  LgPadding,
  ListDescription,
  ListItem,
  MdSpacing,
  XsSpacing,
} from '@alto/design-system';
import React from 'react';
import { AltoPhoneNumber } from '../../alto-assistant/components/AltoPhoneNumber';
export const FamilyMemberConsentAlert = () => {
  return (
    <InlineAlert
      borderless={true}
      type="warning"
    >
      <Description fontFamily="semibold">Adding adult family members</Description>
      <XsSpacing />
      <Description>
        Anyone 18 years or older will need to provide oral or written authorization to be added to your account. Please
        have them contact Alto directly at <AltoPhoneNumber />.
      </Description>
    </InlineAlert>
  );
};

export const FamilyAccountActionSheet = () => {
  return (
    <ActionSheetV2 title="How family accounts work">
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>When you add a family member to your account:</Body>
        <MdSpacing />
        <ListItem
          fullBleed
          LeftContent={
            <Icon
              name="pillbottle"
              type="grey"
            />
          }
          descriptions={
            <ListDescription>
              <Body>You can manage their medications, including scheduling orders and requesting refills</Body>
            </ListDescription>
          }
        />
        <MdSpacing />
        <ListItem
          fullBleed
          LeftContent={
            <Icon
              name="shield"
              type="grey"
            />
          }
          descriptions={
            <ListDescription>
              <Body>You can update insurance on their behalf</Body>
            </ListDescription>
          }
        />
        <MdSpacing />
        <ListItem
          fullBleed
          LeftContent={
            <Icon
              name="message"
              type="grey"
            />
          }
          descriptions={
            <ListDescription>
              <Body>You’ll receive all messages regarding their prescriptions</Body>
            </ListDescription>
          }
        />
        <MdSpacing />
      </LgPadding>
    </ActionSheetV2>
  );
};
